export enum NzIdErrorCodeType {
    EXISTING_ID_BLANK = 'EXISTING_ID_BLANK',
    NEW_ID_BLANK = 'NEW_ID_BLANK',
    EXISTING_ID_NOT_EXIST = 'EXISTING_ID_NOT_EXIST',
    EXISTING_ID_DUPLICATE = 'EXISTING_ID_DUPLICATE',
    NEW_ID_DUPLICATE = 'NEW_ID_DUPLICATE',
    EXISTING_ID_NEW_ID_IDENTICAL = 'EXISTING_ID_NEW_ID_IDENTICAL',
    EXISTING_ID_INACTIVE = 'EXISTING_ID_INACTIVE',
    NEW_ID_NOT_AVAILABLE_ACTIVE_NZO = 'NEW_ID_NOT_AVAILABLE_ACTIVE_NZO',
    NEW_ID_NOT_AVAILABLE_INACTIVE_NZO_WITH_EA = 'NEW_ID_NOT_AVAILABLE_INACTIVE_NZO_WITH_EA',
    PARSING_ERROR = 'PARSING_ERROR'
}
